import { combineReducers } from 'redux';
import { appReducer } from "./app/root/app.reducer";

export default combineReducers({
  app: appReducer
})





// WEBPACK FOOTER //
// ./src/root-reducer.js